import { useHasPermission } from '@app/core/auth/authorization';
import { auditReports } from '@mi-front/api-clients';
import { useRouter } from '@mi-front/core';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { aodRoutes } from '../../../routing/routes';
import { AodRuleDeleteButton } from './AodRuleDeleteButton';

interface AodRuleActionsProps {
  rule: auditReports.AodRule;
}

export function AodRuleActions({ rule }: AodRuleActionsProps) {
  const { formatMessage } = useIntl();
  const { history } = useRouter();

  const handleEdit = () => {
    history.push(aodRoutes.ruleEdit.gen(rule.id));
  };

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {useHasPermission(auditReports.AuditReportsPermissions.AodRules_Manage) && (
        <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={handleEdit}>
          {formatMessage({
            id: 'common.actions.edit',
            defaultMessage: 'Editar',
          })}
        </Button>
      )}
      {useHasPermission(auditReports.AuditReportsPermissions.AodRules_Manage) && (
        <AodRuleDeleteButton rule={rule} />
      )}
    </div>
  );
}
